<footer>
  <p>&copy; {{currentYear}} <span class="fw-semibold"> {{ companyName }}</span> - All rights reserved.</p>
</footer>

